import { createFileRoute } from '@tanstack/react-router';

import { CrochetEditorPage } from '@/pages/crochet-editor/crochet-editor-page';

export const Route = createFileRoute('/crochet/$diagramId')({
    component: CrochetEditorRoute,
    // The properties column owns the account corner; the page-level
    // EditorHeaderTray owns the app-nav corner on desktop.
    staticData: { ownTopLeft: true, ownTopRight: true },
});

function CrochetEditorRoute() {
    const { diagramId } = Route.useParams();
    return <CrochetEditorPage diagramId={diagramId} />;
}
